
import {
  getPaginatedUserLogs,
  markUserLogAsRead,
  markUserLogsAsRead,
} from "@/lib/api/clients/UserLogClient";
import { handleErrorServer, ServerError } from "@/lib/api/errors/ErrorHandler";
import { UserLog } from "@/types/UserLog";

export async function getNotifications(
  page: number,
  size: number,
  olderThan: Date,
  read?: boolean
): Promise<UserLog[] | ServerError> {
  try {
    return await getPaginatedUserLogs(page, size, olderThan, read);
  } catch (error) {
    return handleErrorServer(error);
  }
}

export async function markNotificationAsRead(
  id: string
): Promise<void | ServerError> {
  try {
    return await markUserLogAsRead(id);
  } catch (error) {
    return handleErrorServer(error);
  }
}

export async function markAllNotificationsAsRead(): Promise<void | ServerError> {
  try {
    return await markUserLogsAsRead();
  } catch (error) {
    return handleErrorServer(error);
  }
}
